module.exports = "<div class=\"m-feature-item\">\r\n    <feature-item-1 v-if=\"item.type == 1\" :item=\"item\" :index=\"index\"></feature-item-1>\r\n    <feature-item-2 v-else-if=\"item.type == 2\" :item=\"item\" :index=\"index\"></feature-item-2>\r\n    <feature-item-3 v-else-if=\"item.type == 3\" :item=\"item\" :index=\"index\"></feature-item-3>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!./product-detail/component/feature-item.html
// module id = 261
// module chunks = 0